import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import {
  adapter,
  setValue,
  _updateItem,
  UpdateItemAction,
  _updateShoppingBag,
} from './slice';
import { store } from '@/redux/store';

export const localStorage = createListenerMiddleware();

localStorage.startListening({
  matcher: isAnyOf(_updateShoppingBag, setValue),

  effect: (action: any, listenerApi) => {
    for (const key in action.payload) {
      adapter.setItem(key, action.payload[key]);
    }
  },
});

localStorage.startListening({
  matcher: isAnyOf(_updateItem),

  effect: (action: UpdateItemAction, listenerApi) => {
    const { shoppingItems, wardrobeItems } = store.getState().shoppingBagSlice;

    adapter.setItem('shoppingItems', shoppingItems);
    adapter.setItem('wardrobeItems', wardrobeItems);
  },
});
